import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { cameraSelectionSchema } from './camera-mapping';
import { Vendor } from './vendor';
import { videoIntegrationMetadataPayloadSchema } from './video-integration-metadata-payload';

export type CreateVideoIntegrationPayload = z.output<typeof createVideoIntegrationPayloadSchema>;
export type CreateVideoIntegrationPayloadDTO = z.input<typeof createVideoIntegrationPayloadSchema>;

export const createVideoIntegrationPayloadSchema = z.object({
  cameras: z.array(cameraSelectionSchema).optional(),
  lastSynced: isoDatetimeToDate.optional(),
  meta: videoIntegrationMetadataPayloadSchema.optional(),
  name: z.string().trim().min(1).optional(),
  vendor: z.enum(Vendor),
});
